export const SapIssueForm: React.FC = () => {
	return <div className="text-center">Sap Issue Form goes here</div>;
};
